import { Form } from 'react-bootstrap'
import { ConfigProvider, Select } from 'antd'

export default function SelectBox(props) {

    const { label_name, placeholder, disabled, closeMenu, option, filterOption, name, defaultValue, onChange, onBlur, error, loading, reference, onInputChange, form_group, onClear, mandatory, customOption, value, tabIndex } = props

    return (
        <>
            <Form.Group className={form_group ? form_group : "mb-2"} controlId={name}>
                {label_name === '' ? '' : <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{`${label_name}${mandatory ? '*' : ''}`}</Form.Label>}

                <ConfigProvider
                    theme={{
                        components: {
                            Select: {
                                borderColor: 'rgb(204 204 204)',
                                activeBorderColor: '#436a53',
                                activeOutlineColor: 'none',
                                hoverBorderColor: 'none',
                                optionSelectedColor: '#222124',
                                // optionActiveBg: '#FEF4EA',
                                selectorBg: 'transparent',
                                zIndexPopup: '99999'
                            },
                        },
                        token: {
                            colorBorder: '#ccc',
                            fontFamily: 'Lexend Deca'
                        },
                    }}
                >
                    <Select
                        ref={reference}
                        showSearch
                        allowClear={onClear}
                        size='middle'
                        mode="single"
                        className='antd_custom_select'
                        placeholder={placeholder}
                        disabled={disabled}
                        loading={loading}
                        options={option}
                        optionRender={customOption}
                        filterOption={filterOption}
                        name={name}
                        value={value}
                        onChange={onChange}
                        onSearch={onInputChange}
                        // onFocus={onChange}
                        onBlur={onBlur}
                        // onClear={onClear}
                        tabIndex={tabIndex}

                        style={{
                            width: '100%',
                        }}
                    />
                </ConfigProvider>
                {error}
            </Form.Group>
        </>
    )
}
